export default "__VITE_ASSET__DYXJKZRT__"